/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import HexIcon from '../../../components/CustomIcons/HexIcon/HexIcon';
import { NavLink, useLocation } from 'react-router-dom';
import './SubscriptionFilter.scss';
import useLayout from '../hooks/useLayout';
import { sidemenuItem } from '../Utils/constants';
import { useLogoutMutation } from '../../../store/services/authApi';
import { ColorTheme } from '@components/CustomIcons/HexIconReverse/HexIcon';

function SubscriptionFilter() {
  const { isSideNavigationVisible, isSidemenuIconView } = useLayout();
  const location = useLocation();
  const [logout, formStatus] = useLogoutMutation();
  const [collapsibleMenus, setCollapsibleMenus] = useState<any[]>([]);
  const [expandedMenus, setExpandedMenus] = useState<Set<string>>(new Set());

  useEffect(() => {
    //check if the current URL is a collapsible menu or under a collapsible menu
    const pathname = location.pathname.replace('/', '');
    const collapsible = collapsibleMenus.find(
      (m: any) =>
        m.urlPath === pathname ||
        m.submenu?.find((x: any) => x.urlPath === pathname || x.chainUrls?.some((item: any) => item === pathname))
    );

    let updatedMenus: any[];
    if (collapsible) {
      updatedMenus = collapsibleMenus.map((menu) =>
        menu.urlPath === pathname ||
          menu.submenu?.find((x: any) => x.urlPath === pathname || x.chainUrls?.some((item: any) => item === pathname))
          ? {
            ...collapsible,
            isCollapsed: true,
          }
          : {
            ...menu,
            isCollapsed: false,
          }
      );
    } else {
      updatedMenus = collapsibleMenus.map((menu) => {
        return {
          ...menu,
          isCollapsed: false,
        };
      });
    }

    setCollapsibleMenus(updatedMenus);

    // Auto-expand menu if current path matches a submenu item
    const matchingMenu = sidemenuItem[0].items.find((item: any) =>
      item.submenu?.some((sub: any) =>
        sub.urlPath === pathname || sub.chainUrls?.some((url: any) => url === pathname)
      )
    );

    if (matchingMenu) {
      setExpandedMenus(new Set([matchingMenu.displayName]));
    }
  }, [location.pathname, sidemenuItem]);

  const getNestedMenu = (menu: any): JSX.Element | null => {
    return (
      <li className="sub-menu flex flex-row">
        <div className="vertical-divider">
          <div />
        </div>
        <div className="w-100">
          <ul>
            {menu.submenu?.map((item: any, key: number) => (
              <li key={key}>
                <NavLink
                  to={item.urlPath ?? ''}
                  className={({ isActive }) =>
                    isActive || item.chainUrls?.some((x: any) => x === location.pathname.replace('/', ''))
                      ? 'sidemenu-selected'
                      : ''
                  }
                  end
                >
                  <span>{item.displayName}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </li>
    );
  };

  const getMenu = (): JSX.Element[] => {
    return sidemenuItem[0].items.map((item, key) => {
      const hasSubmenu = item.submenu && item.submenu.length > 0;
      const isExpanded = expandedMenus.has(item.displayName);

      return (
        <React.Fragment key={key}>
          <li className="relative">
            {hasSubmenu ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedMenus(prev => {
                    const newSet = new Set(prev);
                    if (newSet.has(item.displayName)) {
                      newSet.delete(item.displayName);
                    } else {
                      newSet.add(item.displayName);
                    }
                    return newSet;
                  });
                }}
                className={`${item.color}-themed-box has-submenu ${isExpanded ? 'sidemenu-selected' : ''}`}
              >
                <HexIcon icon={item.icon} colorTheme={item.color as ColorTheme} colorMode="fill" />
                <span>{item.displayName}</span>
                <i className={`icon icon-chevron-${isExpanded ? 'up' : 'down'} collapse-menu-icon`} />
              </a>
            ) : (
              <NavLink
                to={item.urlPath ?? ''}
                className={({ isActive }) =>
                  `${item.color}-themed-box ${isActive ? 'sidemenu-selected non-collapsible-selected' : ''}`
                }
                end
              >
                <HexIcon icon={item.icon} colorTheme={item.color as ColorTheme} colorMode="fill" />
                <span>{item.displayName}</span>
              </NavLink>
            )}
          </li>

          {isExpanded && hasSubmenu && getNestedMenu(item)}
        </React.Fragment>
      );
    });
  };

  const triggerLogout = () => {
    logout('');
  };

  return (
    <aside className={`${isSideNavigationVisible ? 'sidemenu-visible ' : ''}${isSidemenuIconView ? 'sidemenu-icon-view' : ''}`}>
      <section className="menu-row">
        <ul className="flex flex-col">{getMenu()}</ul>
      </section>

      <div className="row-divider" />

      <section className="menu-row">
        <ul>
          <li onClick={triggerLogout}>
            <NavLink to="/subscription" end>
              <HexIcon icon="logout" colorTheme="green" />
              <span>Logout</span>
            </NavLink>
          </li>
        </ul>
      </section>
    </aside>
  );
}

export default SubscriptionFilter;